/*
 * THCC · colección y búsqueda: mejora progresiva.
 * Sin este archivo todo funciona con formularios GET estándar y el popover declarativo de la hoja de filtros
 * (botón "Filtrar" con popovertarget, velo y Esc los resuelve el navegador). Con él:
 *  - en escritorio los filtros y el orden se aplican al cambiar (en móvil se aplican con "Ver N productos");
 *  - la hoja devuelve el foco al botón que la abrió y se cierra si la ventana pasa a escritorio.
 * Los parámetros los generan los propios campos del formulario (nombres de Shopify); aquí no se arma ninguna URL.
 */

const ESCRITORIO = window.matchMedia('(min-width: 1100px)');

function enviar(form) {
  if (typeof form.requestSubmit === 'function') form.requestSubmit();
  else form.submit();
}

function iniciarFiltros(raiz) {
  const form = raiz.querySelector('[data-thcc-filtros-form]');
  if (!form) return;

  let temporizador = 0;
  form.addEventListener('change', (e) => {
    if (!ESCRITORIO.matches) return;
    if (!(e.target instanceof HTMLInputElement)) return;
    // Los interruptores "Mostrar más" no llevan nombre: no son filtros.
    if (!e.target.name) return;
    window.clearTimeout(temporizador);
    temporizador = window.setTimeout(() => enviar(form), e.target.type === 'text' ? 450 : 0);
  });

  const abridores = document.querySelectorAll('[popovertarget="thcc-filtros"]:not(.thcc-cf__velo):not(.thcc-cf__cerrar)');
  const panel = raiz.querySelector('[data-thcc-filtros-panel]');
  let origen = null;

  abridores.forEach((a) => a.addEventListener('click', () => { origen = a; }));

  raiz.addEventListener('toggle', (e) => {
    const abierto = e.newState === 'open';
    abridores.forEach((a) => a.setAttribute('aria-expanded', abierto ? 'true' : 'false'));
    if (abierto && panel) panel.focus({ preventScroll: true });
    if (!abierto && origen) {
      origen.focus({ preventScroll: true });
      origen = null;
    }
  });

  ESCRITORIO.addEventListener('change', () => {
    if (ESCRITORIO.matches && typeof raiz.hidePopover === 'function' && raiz.matches(':popover-open')) {
      raiz.hidePopover();
    }
  });
}

function iniciarOrden() {
  document.querySelectorAll('[data-thcc-orden]').forEach((form) => {
    const select = form.querySelector('select');
    if (select) select.addEventListener('change', () => enviar(form));
  });
}

document.querySelectorAll('[data-thcc-filtros]').forEach(iniciarFiltros);
iniciarOrden();
